import {
  AfterContentChecked,
  AfterContentInit,
  Directive,
  ElementRef,
  HostListener,
  inject,
  Renderer2
} from '@angular/core';
import { Panel as PanelService } from '../panel.svc';

/**
 * @description This directive is meant to be attached to a `<button />`
 *   element in the OkePanel's _header_ element. That `<button />`
 *   element is the first immediate child of the `okePanelHeader` tag
 *   (element). This directive adds functionality to enable
 *   showing/hiding the OkePanel's body contents.
 */
@Directive({
  selector: '[okePanelCollapsible]'
})
export class Collapsible implements AfterContentInit, AfterContentChecked {
  private readonly _panelSvc: PanelService = inject(PanelService, {
    host: true
  });
  private readonly _elem: ElementRef = inject(ElementRef);
  private readonly _renderer: Renderer2 = inject(Renderer2);

  constructor() {
    this._elem.nativeElement.classList.add('btn--collapsible');
  }

  @HostListener('click', ['$event'])
  onCollapsibleButtonClicked(clickEvt: PointerEvent): void {
    const isVisible = this._panelSvc.$state().collapsible.is;
    this._panelSvc.updateState('collapsible', {
      is: !isVisible
    });
  }

  private _updateState(): void {
    if (!this._elem) {
      return;
    }
    this._panelSvc.updateState('collapsible', {
      isListening: true
    });
    this._renderer.setAttribute(
      this._elem.nativeElement,
      'data-tooltip',
      `Collapse ${this._panelSvc.$state().header.title ?? 'panel'}`
    );
  }

  ngAfterContentInit(): void {
    if (!this._elem) {
      return;
    }
    this._updateState();
  }

  ngAfterContentChecked(): void {
    if (this._panelSvc.$state().collapsible.isListening) {
      return;
    }
    this._updateState();
  }
}
